import React from 'react';
import {
    User,
    Bell,
    Shield,
    Key,
    Palette,
    CreditCard // Added CreditCard icon
} from 'lucide-react';
import './Settings.css';

function Settings() {
    const settingsSections = [
        {
            icon: User,
            title: 'Profile',
            description: 'Manage your account details and preferences'
        },
        {
            icon: Bell,
            title: 'Notifications',
            description: 'Configure email and push notification settings'
        },
        {
            icon: Key,
            title: 'API Keys',
            description: 'Manage your API keys for CI/CD integration'
        },
        {
            icon: Shield,
            title: 'Security',
            description: 'Password, two-factor authentication, and sessions'
        },
        {
            icon: Palette,
            title: 'Appearance',
            description: 'Customize the look and feel of the dashboard'
        }
    ];

    return (
        <div className="settings-page">
            <div className="page-header">
                <h1 className="page-title">Settings</h1>
                <p className="page-subtitle">Manage your account and application preferences</p>
            </div>

            <div className="settings-grid">
                {settingsSections.map((section, index) => (
                    <div key={index} className="settings-card">
                        <div className="settings-icon">
                            <section.icon size={24} />
                        </div>
                        <div className="settings-content">
                            <h3 className="settings-title">{section.title}</h3>
                            <p className="settings-desc">{section.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Settings;
